module.exports = __webpack_public_path__ + "static/pc_rss/img/qrcode_for_gh_3c0cf27cfbd1_430.17c1460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qrcode_for_gh_3c0cf27cfbd1_430.jpg
// module id = 109
// module chunks = 15